import React from "react";
import { FlexContainer, StandardModalActionButton, TextLabel } from "src/components";
import CheckIcon from "src/img/check@2x.png";
import { PlanActionButton, ActionButton } from "./style";
import ArrowRIght from "src/img/arrowRight.svg";
import { DOWNGRADE_STATUS } from "../constants";

export default function EmailDowngradeModal({
    onBack,
    currentPlan,
    downgradePlan,
    openFinalModal,
    status
}) {

    return (
        <FlexContainer
            direction="column"
            alignItems="center"
            gap="1rem"
        >

            {/* CARD DISPLAY */}
            <FlexContainer
                direction="row"
                gap="24px"
                alignItems="center"
                justifyContent="center"
            >
                <PackageCard
                    title="Current Package"
                    plan={currentPlan}
                    isCurrent
                    openFinalModal={openFinalModal}
                    status={status}
                />

                <Arrow />

                <PackageCard
                    title="New Package"
                    plan={downgradePlan}
                    openFinalModal={openFinalModal}
                    status={status}
                />
               
            </FlexContainer>
            <FlexContainer width="592px">
                <TextLabel size="14px" color={"#171A22"} align="center">
                    { status === DOWNGRADE_STATUS.CANCEL ?
                        `Cancelling will keep your current plan and stop the downgrade to ${downgradePlan.title}.`
                        :
                        "You can upgrade again at any time before your renewal."
                    }
                </TextLabel>
            </FlexContainer>
            {/* ACTIONS */}
            <FlexContainer direction="row" mDirection="row" tDirection="row" justifyContent="flex-start" gap="20px">
                { status === DOWNGRADE_STATUS.CANCEL ? (
                    <ActionButton onClick={onBack}>Close</ActionButton>
                ) : (
                    <StandardModalActionButton
                        $variant="primary"
                        width="12rem"
                        onClick={onBack}
                    >
                        Go to Email Campaigns
                    </StandardModalActionButton>
                ) }
               
            </FlexContainer>
        </FlexContainer>
    );
}


function PackageCard({ title, plan, isCurrent = false, openFinalModal, status = DOWNGRADE_STATUS.DOWNGRADE }) {

    const price = getPlanPrice(plan);
    const priceLabel =
        price === 0 ? "FREE" : `AUD $${price} / year`;

    const buttonText = isCurrent
        ? "Current Plan"
        : status === DOWNGRADE_STATUS.CANCEL
            ? "Cancel Downgrade"
            : "Downgrade";

    const buttonVariant = isCurrent
        ? "current"
        : status === DOWNGRADE_STATUS.CANCEL
            ? "cancel-downgrade"
            : "upgrade"; 

    const cardBorder = isCurrent && status === DOWNGRADE_STATUS.CANCEL
        ? "2px solid #D8DEEC"
        : isCurrent
            ? "2px solid #171A22"
            : "1px solid #D8DEEC"; 
        
    return (
        <FlexContainer
            width="253px"
            height="351px"
            borderRadius="12px"
            padding="20px"
            direction="column"
            style={{
                boxShadow: "0px 3px 6px #00000029",
                background: "#FFFFFF",
                border: cardBorder,
            }}
        >
            {/* HEADER */}
            <FlexContainer
                direction="column"
                alignItems="center"
                gap="6px"
                style={{ flexShrink: 0 }}
            >
                <TextLabel size="14px" weight="700">
                    {title}
                </TextLabel>

                <TextLabel color="#171A22" size="30px" weight="900">
                    {plan?.title}
                </TextLabel>

                <TextLabel color="#171A22" size="15px" weight="600">
                    {priceLabel}
                </TextLabel>

                <TextLabel size="14px" align="center">
                    {plan?.description}
                </TextLabel>
            </FlexContainer>

            {/* FEATURES */}
            <FlexContainer
                direction="column"
                alignItems="center"
                gap="5px"
                style={{
                    flexGrow: 1,
                    overflowY: "auto",
                    marginTop: "10px",
                }}
            >
                <TextLabel size="15px" weight="700">
                    Includes:
                </TextLabel>

                {plan?.includes?.map((perk, i) => (
                    <FlexContainer
                        key={i}
                        direction="row"
                        gap="5px"
                        alignItems="center"
                        justifyContent="center"
                    >
                        <TextLabel size="14px" weight="500">
                            {perk}
                        </TextLabel>
                        <TextLabel size="14px">
                            {i === 0 ? "Monthly Sends" : "Imported Contacts"}
                        </TextLabel>
                    </FlexContainer>
                ))}

                <TextLabel size="14px">No Daily Limit</TextLabel>

                {isCurrent && (
                    <img
                        src={CheckIcon}
                        alt="Current Plan"
                        width="28"
                        height="28"
                    />
                )}
            </FlexContainer>

            {/* FOOTER */}
            <FlexContainer justifyContent="center" style={{ flexShrink: 0 }}>
                <PlanActionButton
                    style={{ width: "142px", alignSelf: "center" }}
                    variant={buttonVariant}
                    disabled={isCurrent}
                    onClick={
                        status === DOWNGRADE_STATUS.CANCEL
                            ? openFinalModal
                            : !isCurrent
                                ? () => openFinalModal(plan)
                                : undefined
                    }
                >
                    {buttonText}
                </PlanActionButton>
            </FlexContainer>
        </FlexContainer>
    );
}


const Arrow = () => (
    <FlexContainer alignItems="center">
        <img src={ArrowRIght} width="40px" height="40px"/>
    </FlexContainer>
);

const getPlanPrice = (plan) => {
    if (!plan) return 0;

    const price = Number(plan.price);
    if (!isNaN(price) && price >= 0) return price;

    const priceCents = Number(plan.priceCents);
    if (!isNaN(priceCents) && priceCents >= 0) return priceCents / 100;

    return 0;
};
